import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ISchedule } from './schedule.model';

@Injectable()
export class ScheduleService {
  constructor(private $http: HttpClient) {}

  // private subscibersUrl = '';
  // getSubscribers() {
  //   // :Observable<ISchedule>
  //   // return this.$http.get(this.subscribersUrl)
  //   // .map((res:Response) => res.json())
  //   // .catch((error: any) => Observable.throw(error.json().error || 'Server Error'));
  //   return {
  //     allocated: [
  //       {},
  //       { name: 'Voicu Iulia', slot: 's2' },
  //       { name: '', slot: 's3' }
  //     ],
  //     others: [
  //       { name: 'Iacob Rares', hireDate: 'Jan 7th 17', slot: 's1' },
  //       { name: 'Voicu Iulia', hireDate: 'Feb 7th 18', slot: 's2' },
  //       { name: 'Popoviciu Sebastian', hireDate: 'Nov 7th 18', slot: 's3' }
  //     ]
  //   };
  // }
  getWeekSchedule(year: number, weekNumber: Number) {
    return this.$http.get<ISchedule[]>(`schedules/year/${year}/week/${weekNumber}`);
  }
  parkToggle(data) {
    return this.$http.post('schedules', data);
  }
}
